import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_PROFESSIONAL_LIST = 'DELETE_PROFESSIONAL_LIST';
export const DELETE_PROFESSIONAL_LIST_SUCCESS =
  'DELETE_PROFESSIONAL_LIST_SUCCESS';
export const DELETE_PROFESSIONAL_LIST_FAILURE =
  'DELETE_PROFESSIONAL_LIST_FAILURE';

// Action Creators
export const deleteProfessionalList = () => ({
  type: DELETE_PROFESSIONAL_LIST,
});

export const deleteProfessionalListSuccess = (users) => ({
  type: DELETE_PROFESSIONAL_LIST_SUCCESS,
  payload: users,
});

export const deleteProfessionalListFailure = (error) => ({
  type: DELETE_PROFESSIONAL_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteProfessionalData = (external, id) => {
  return async (dispatch) => {
    dispatch(deleteProfessionalList());
    try {
      const response = await deleteMethodWithToken(
        url?.deleteProfessionalList + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deleteProfessionalListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(deleteProfessionalListFailure(error?.message));
    }
  };
};
